/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ACSBaseService } from '../acs-base-service';
import { ACSApiConfiguration } from '../acs-api-configuration';
import { ACSStrictHttpResponse } from '../acs-strict-http-response';

import { queueLeaveDelete } from '../fn/queue/queue-leave-delete';
import { QueueLeaveDelete$Params } from '../fn/queue/queue-leave-delete';
import { queuePositionGet } from '../fn/queue/queue-position-get';
import { QueuePositionGet$Params } from '../fn/queue/queue-position-get';
import { QueuePositionModel } from '../models/queue-position-model';

@Injectable({ providedIn: 'root' })
export class ACSQueueService extends ACSBaseService {
  constructor(config: ACSApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `queuePositionGet()` */
  static readonly QueuePositionGetPath = '/Queue/Position';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `queuePositionGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  queuePositionGet$Response(params?: QueuePositionGet$Params, context?: HttpContext): Observable<ACSStrictHttpResponse<QueuePositionModel>> {
    return queuePositionGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `queuePositionGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  queuePositionGet(params?: QueuePositionGet$Params, context?: HttpContext): Observable<QueuePositionModel> {
    return this.queuePositionGet$Response(params, context).pipe(
      map((r: ACSStrictHttpResponse<QueuePositionModel>): QueuePositionModel => r.body)
    );
  }

  /** Path part for operation `queueLeaveDelete()` */
  static readonly QueueLeaveDeletePath = '/Queue/Leave';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `queueLeaveDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  queueLeaveDelete$Response(params?: QueueLeaveDelete$Params, context?: HttpContext): Observable<ACSStrictHttpResponse<void>> {
    return queueLeaveDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `queueLeaveDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  queueLeaveDelete(params?: QueueLeaveDelete$Params, context?: HttpContext): Observable<void> {
    return this.queueLeaveDelete$Response(params, context).pipe(
      map((r: ACSStrictHttpResponse<void>): void => r.body)
    );
  }

}
